import api from './client';

export const fetchAuditLog = (params) => api.get('/admin/audit_log', { params });
